export default "__VITE_ASSET__xbvTFQg3__"